<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{data.title}}</h1>
<div mat-dialog-content class="mbp-confirm-dialog__content">
  <p class="mbp-confirm-dialog__message">{{data.message}}</p>
</div>
<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
  <button mat-stroked-button [mat-dialog-close]="false">{{data.no}}</button>
  <button mat-flat-button [mat-dialog-close]="true" color="primary" cdkFocusInitial>{{data.yes}}</button>
</div>
